import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { CloudUpload as FileIcon } from "mdi-material-ui";

const Icon = () => <FileIcon />;

const Title = () => <span>Fichier attaché</span>;

const Content = ({ orderEvent }) => (
  <Typography>
    <a href={orderEvent.file.url} target="_blank" rel="noopener noreferrer">
      {orderEvent.file.name}
    </a>
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_FileEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_File {
        file {
          id
          name
          url
        }
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
